import { useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { explorerActions, selectSceneId } from "slices/explorer";

export const DEFAULT_SCENE_ID = import.meta.env.REACT_APP_SCENE_ID ?? "95a89d20dd084d9486e383e131242c4c";

export function useSceneId() {
    const storeSceneId = useAppSelector(selectSceneId);
    const dispatch = useAppDispatch();

    const { id = DEFAULT_SCENE_ID } = useParams<{
        id?: string;
    }>();

    // This is not really needed as explorer slice sceneId is only used here,
    // but just for consistency
    if (id && !storeSceneId) {
        dispatch(explorerActions.setSceneId(id));
    }

    return storeSceneId || id;
}
